<div class="site-content">
<article class="wow animate__animated animate__fadeInUp post">
    <img class="v-art vertical" src="assets/img/face.png" />
</article>
<img class="v-art-separator" src="assets/img/separator.png" />
<article class="wow animate__ animate__fadeInUp post">
    <img class="v-art vertical" src="assets/img/car-transparent2.png" />
</article>
</div>